import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import {
  isInViewFooterState,
  stepState,
  inputState,
  inputtedEmailState,
  productsState,
  onetimeKeyState,
} from '../../../states/messageState'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'
import { putVerifyCode } from '../../../api/verify'
import { getProductsByEmail } from '../../../api/contracts'
import { useRequestFailed } from '../../../hooks/useRequestFailed'

export const InputVerifyCode: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const [input, setInput] = useRecoilState(inputState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setProducts = useSetRecoilState(productsState)
  const setCurrentStep = useSetRecoilState(stepState)
  const inputtedEmail = useRecoilValue(inputtedEmailState)
  const setOnetimeKey = useSetRecoilState(onetimeKeyState)
  const { requestFailed } = useRequestFailed()

  /**メールに送信されたコード */
  const handleSubmitVerifyCode = async () => {
    try {
      await handleAddSenderParent('user', input)
      setIsInViewFooter(false)
      const { onetimeKey } = await putVerifyCode({
        email: inputtedEmail,
        verifyCode: input,
      })
      const products = await getProductsByEmail(onetimeKey)

      if (!products.length) throw new Error()

      const message =
        products.length > 1
          ? '保証契約が見つかりました。今回申請する保証契約を選択して下さい。'
          : 'こちらの保証契約で申請を進めてよろしいでしょうか？'

      await handleAddSenderParent('bot', message)

      setProducts(products)
      setOnetimeKey(onetimeKey)
      handleInViewFooter()
      setCurrentStep('chooseProduct')
    } catch {
      await requestFailed()
    } finally {
      setInput('')
    }
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder="6桁のコード"
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmitVerifyCode()}
        onClick={handleSubmitVerifyCode}
      />
    </FooterContent>
  )
}
